import {Component, MouseEvent} from "react";
import {AppState} from "../AppState";
import {Action, Dispatch} from "redux";
import {WorkforceOneUserLogOut} from "../actions/WorkforceOneLoginActions";
import {connect} from "react-redux";

export interface MouseDetectionLogoutTimerDispatchProps{
    logOut: () => void
}
export interface MouseDetectionLogoutTimerAppStateProps{
    loggedIn: boolean
}
export interface MouseDetectionLogoutTimerProps{

}

const sixtyMinutesInMilliSeconds = 3600000;
export class MouseDetectionLogoutTimer extends Component<MouseDetectionLogoutTimerDispatchProps & MouseDetectionLogoutTimerAppStateProps & MouseDetectionLogoutTimerProps>{

    mouseMoveTimeOut: NodeJS.Timeout | undefined;

    componentDidMount() {
        if(this.props.loggedIn){
            this.mouseMoveTimeOut = setTimeout(() => this.timerRanOut(), sixtyMinutesInMilliSeconds);
        }
    }
    componentWillUnmount() {
        if(this.mouseMoveTimeOut) {
            clearTimeout(this.mouseMoveTimeOut);
        }
    }
    timerRanOut = () => {
        if(this.props.loggedIn){
            this.props.logOut();
        }
    }
    mouseMoved = (e: MouseEvent) => {
        if(this.mouseMoveTimeOut) {
            clearTimeout(this.mouseMoveTimeOut);
        }
        if(this.props.loggedIn){
            this.mouseMoveTimeOut = setTimeout(() => this.timerRanOut(), sixtyMinutesInMilliSeconds);
        }
    }

    render() {
        return (<div onMouseMove={e => this.mouseMoved(e)}>
            {this.props.children}
        </div>);
    }
}
function mapStateToProps(state: AppState): MouseDetectionLogoutTimerAppStateProps {
    return {
        loggedIn: state.Workforce1State.isLoggedIn
    }
}
function mapDispatchProps(dispatch: Dispatch<Action>): MouseDetectionLogoutTimerDispatchProps {
    return {
        logOut: () => dispatch(WorkforceOneUserLogOut()),
    }
}
const connector = connect<MouseDetectionLogoutTimerAppStateProps, MouseDetectionLogoutTimerDispatchProps, MouseDetectionLogoutTimerProps, AppState>(
    mapStateToProps, mapDispatchProps)(MouseDetectionLogoutTimer);
export default connector;
